module.exports = __webpack_public_path__ + "img/Arduino+Remote.2501285b.jpg";